import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  auditInformation,
  getAuditTimeLine,
  getFindsandissuesChartData,
  getFindsandissuestableData,
  getEscalation,
  getProgressmetrics,
  getGeneralInfo,
  getResourceUtilization,
  getResponseAnalysis,
  getResponseAnalysisByTheme,
} from "../../api/common";
import LoadingOverlay from "../../Components/LoadingOverlay";
import { ERROR_MESSAGE } from "../../constants";
import AuditorDashboard from "../../Containers/AuditorDashboard";
import { RootState } from "../../store";
import PageContainer from "../PageContainer";
import Alert from "../../Components/AlertPopup";
import { encrypt } from "../../utils";
import styles from "./style.module.scss";
const Dashboard = () => {
  const userInfo = useSelector((state: RootState) => state.user);
  //const [userInfo, setUserInfo] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [errorMessage, setErrorMessage] = useState(
    ERROR_MESSAGE.API_ERROR_MESSAGE
  );
  const [cardLoading, setCardLoading] = useState(false);
  const [auditInfoData, setAuditInfoData] = useState<any>([]);
  const [timeLineData, setTimeLineData] = useState<any>([]);
  const [generalInfo, setGeneralInfo] = useState<any>([]);
  const [resourceUtilData, setResourceUtilData] = useState<any>([]);
  const [findIssueChartData, setFindIssueChartDataData] = useState<any>([]);
  const [escalationData, setEscalationData] = useState<any>([]);
  const [progressData, setProgressData] = useState<any>([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [responseAnalysisData, setResponseAnalysisData] = useState<any>([]);
  const [responseAnalysisThemeData, setResponseAnalysisThemeData] =
    useState<any>([]);

  useEffect(() => {
    setLoading(true);
    auditInformation()
      .then((response) => {
        setAuditInfoData(response?.audits);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        setShowErrorToast(true);
        setTimeout(() => handleErrorClose(), 3000);
      });
  }, []);

  const handleFindingChartClick = (id: number, severity: string) => {
    setTableLoading(true);
    getFindsandissuestableData(id, severity)
      .then((response) => {
        setTableLoading(false);
        setTableData(response);
      })
      .catch(() => {
        setShowErrorToast(true);
        setTableLoading(false);
        setTimeout(() => handleErrorClose(), 3000);
      });
  };

  type Severity = "Critical" | "High" | "Medium" | "Low";

  interface Finding {
    questionId: number;
    severity: Severity;
  }

  function getTopSeverity(findings: Finding[]): Severity {
    const priorityOrder: Severity[] = ["Critical", "High", "Medium", "Low"];

    // Create a Set of severities present for quick lookup
    const severitiesPresent = new Set(findings.map((f) => f.severity));

    for (const severity of priorityOrder) {
      if (severitiesPresent.has(severity)) {
        return severity;
      }
    }

    // Fallback if no severity found (empty array or no matching severities)
    return "Critical";
  }

  const getTabDetails = (tab: string, id: number) => {
    switch (tab) {
      case "General Details":
        setCardLoading(true);

        Promise.all([
          getGeneralInfo(encrypt(id)),
          getAuditTimeLine(encrypt(id)),
          getProgressmetrics(id),
        ])
          .then(([generalInfo, timeLine, progress]) => {
            setGeneralInfo(generalInfo);
            setTimeLineData(timeLine);
            setProgressData(progress);
          })
          .catch(() => {
            setShowErrorToast(true);
            setTimeout(() => handleErrorClose(), 3000);
          })
          .finally(() => {
            setCardLoading(false);
          });
        break;
      case "Questionnaire Analysis":
        if (
          auditInfoData.filter((data: any) => data.id === id)[0]?.status ===
          "In Progress" ||
          auditInfoData.filter((data: any) => data.id === id)[0]?.status ===
          "Completed"
        ) {
          setCardLoading(true);
          getResponseAnalysis(id)
            .then((responseAnalysis) => {
              setResponseAnalysisData(responseAnalysis);
            })
            .catch(() => {
              setResponseAnalysisData([]);
              setShowErrorToast(true);
              setTimeout(() => handleErrorClose(), 3000);
            });

          getResponseAnalysisByTheme(id)
            .then((responseAnalysisByTheme) => {
              setResponseAnalysisThemeData(responseAnalysisByTheme);
            })
            .catch(() => {
              setResponseAnalysisThemeData([]);
              setShowErrorToast(true);
              setTimeout(() => handleErrorClose(), 3000);
            })
            .finally(() => {
              setCardLoading(false);
            });

        }
        break;
      case "Findings & Issues":
        setCardLoading(true);
        getFindsandissuesChartData(id)
          .then((response) => {
            setFindIssueChartDataData(response);
            handleFindingChartClick(id, getTopSeverity(response.heatMap));
            setCardLoading(false);
          })
          .catch(() => {
            setShowErrorToast(true);
            setCardLoading(false);
            setTimeout(() => handleErrorClose(), 3000);
          });
        break;
      case "Escalations":
        setCardLoading(true);
        getEscalation(id)
          .then((response) => {
            setEscalationData(response);
            setCardLoading(false);
          })
          .catch(() => {
            setShowErrorToast(true);
            setCardLoading(false);
            setTimeout(() => handleErrorClose(), 3000);
          });
        break;
      case "Resource Utilization":
        setCardLoading(true);
        getResourceUtilization(id)
          .then((response) => {
            setResourceUtilData(response);
            setCardLoading(false);
          })
          .catch(() => {
            setShowErrorToast(true);
            setCardLoading(false);
            setTimeout(() => handleErrorClose(), 3000);
          });
        break;
    }
  };
  const handleErrorClose = () => setShowErrorToast(false);
  return (
    <PageContainer>
      <div className={styles.title}>Audit Insights</div>
      <LoadingOverlay loading={loading} />
      <>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: "25px",
            width: "100%",
          }}
        >
          <div style={{ textAlign: "left", width: "90%" }}></div>
          <div></div>
        </div>
        <AuditorDashboard
          auditInfoData={auditInfoData ?? []}
          getTabDetails={getTabDetails}
          timeLineData={timeLineData ?? []}
          cardLoading={cardLoading}
          findIssueChartData={findIssueChartData ?? []}
          escalationData={escalationData ?? []}
          handleFindingChartClick={handleFindingChartClick}
          FindingstableLoading={tableLoading}
          FindingstableData={tableData ?? []}
          progressData={progressData ?? []}
          generalInfo={generalInfo ?? []}
          resourceUtilData={resourceUtilData ?? []}
          responseAnalysisData={responseAnalysisData ?? []}
          responseAnalysisThemeData={responseAnalysisThemeData ?? []}
        />
      </>
      <Alert
        type="error"
        show={showErrorToast}
        onClose={handleErrorClose}
        message={errorMessage}
      />
    </PageContainer>
  );
};

export default Dashboard;
